import {
  CLEAR_BED_WING,
  CLEAR_BED_ROOM,
  CLEAR_BED_FLOOR,
  CLEAR_BED_TYPES,
  CLEAR_BED,
  GETSETUPWINGLOCATION,
  CREATESETUPWINGLOCATION,
  UPDATESETUPWINGLOCATION,
  DELETESETUPWINGLOCATION,
  GETSETUPROOMOCATION,
  CREATESETUPROOMOCATION,
  UPDATESETUPROOMOCATION,
  DELETESETUPROOMOCATION,
  axios,
  baseURL,
  GETSETUPHRSURVEYTEMPLATE,
  CREATESETUPHRSURVEYTEMPLATE,
  UPDATESETUPHRSURVEYTEMPLATE,
  DELETESETUPHRSURVEYTEMPLATE,
  GETSETUPHRTEMPLATE,
  CREATESETUPHRTEMPLATE,
  UPDATESETUPHRTEMPLATE,
  DELETESETUPHRTEMPLATE,
  GETSETUPHRCESSTAX,
  CREATESETUPHRCESSTAX,
  UPDATESETUPHRCESSTAX,
  DELETESETUPHRCESSTAX,
  GETSETUPHRSURCHARGETAX,
  CREATESETUPHRSURCHARGETAX,
  UPDATESETUPHRSURCHARGETAX,
  DELETESETUPHRSURCHARGETAX,
  GETSETUPHRATTENDANCETYPE,
  CREATESETUPHRATTENDANCETYPE,
  UPDATESETUPHRATTENDANCETYPE,
  DELETESETUPHRATTENDANCETYPE,
  GETSETUPHRPROFESSIONALTAX,
  CREATESETUPHRPROFESSIONALTAX,
  UPDATESETUPHRPROFESSIONALTAX,
  DELETESETUPHRPROFESSIONALTAX,
  GETSETUPHRINCOMETAX,
  CREATESETUPHRINCOMETAX,
  UPDATESETUPHRINCOMETAX,
  DELETESETUPHRINCOMETAX,
  GETLEAVETYPE,
  CREATELEAVETYPE,
  UPDATELEAVETYPE,
  DELETELEAVETYPE,
  CREATEDEPARTMENT,
  GETDEPARTMENT,
  UPDATEDEPARTMENT,
  DELETEDEPARTMENT,
  CREATEDESIGNATION,
  GETDESIGNATION,
  UPDATEDESIGNATION,
  DELETEDESIGNATION,
  CREATESPECIALITY,
  GETSPECIALITY,
  UPDATESPECIALITY,
  DELETESPECIALITY,
  CREATEPAYROLLTYPE,
  GETPAYROLLTYPE,
  UPDATEPAYROLLTYPE,
  DELETEPAYROLLTYPE,
  DELETEPAYROLL,
  UPDATEPAYROLL,
  GETPAYROLL,
  CREATEPAYROLL,
  GETAllSPECIALITY,
  CREATE_TWOSTEP_VERIFICATION,
  GET_TWOSTEP_VERIFICATION,
  UPDATE_TWOSTEP_VERIFICATION,
  DELETE_TWOSTEP_VERIFICATION
} from "./types";

export const createLeavetype = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupleavetype/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATELEAVETYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getLeavetype = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setupleavetype/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETLEAVETYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateLeavetype = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupleavetype/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATELEAVETYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteLeavetype = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupleavetype/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETELEAVETYPE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const createDepartment = (data) => async (dispatch) => {
  try {
    var config = {
      method: "post",
      url: baseURL + "/api/setupdepartment/create",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    dispatch({
      type: CREATEDEPARTMENT,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const getDepartment = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setupdepartment/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETDEPARTMENT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateDepartment = (data) => async (dispatch) => {
  try {
    var config = {
      method: "patch",
      url: baseURL + "/api/setupdepartment/update",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    dispatch({
      type: UPDATEDEPARTMENT,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const deleteDepartment = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupdepartment/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEDEPARTMENT,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createDesignation = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupdesignation/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEDESIGNATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getDesignation = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setupdesignation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETDESIGNATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateDesignation = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupdesignation/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEDESIGNATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteDesignation = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupdesignation/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEDESIGNATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSpeciality = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupspeciality/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSpeciality = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setupspeciality/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETSPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getAllSpeciality = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setupspeciality/getallAdmin",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETAllSPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateSpeciality = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupspeciality/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSpeciality = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupspeciality/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESPECIALITY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPayroll = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuppayroll/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETPAYROLL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createPayroll = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuppayroll/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATEPAYROLL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updatePayroll = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuppayroll/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEPAYROLL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deletePayroll = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuppayroll/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETEPAYROLL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};


export const getAttendance = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrattendancetype/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPHRATTENDANCETYPE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createAttendance = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrattendancetype/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPHRATTENDANCETYPE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateAttendance = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrattendancetype/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPHRATTENDANCETYPE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteAttendance = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrattendancetype/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPHRATTENDANCETYPE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getsetuphrprofessionaltax = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrprofessionaltax/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPHRPROFESSIONALTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createsetuphrprofessionaltax = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrprofessionaltax/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPHRPROFESSIONALTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updatesetuphrprofessionaltax = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrprofessionaltax/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPHRPROFESSIONALTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deletesetuphrprofessionaltax = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrprofessionaltax/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPHRPROFESSIONALTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getsetuphrIncomeTax = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrincometax/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPHRINCOMETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createsetuphrIncomeTax = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrincometax/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPHRINCOMETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updatesetuphrIncomeTax = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrincometax/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPHRINCOMETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deletesetuphrIncomeTax = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrincometax/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPHRINCOMETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getsetuphrSurchagrTax = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrsurcharge/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPHRSURCHARGETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createsetuphrSurchagrTax = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrsurcharge/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPHRSURCHARGETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updatesetuphrSurchagrTax = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrsurcharge/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPHRSURCHARGETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deletesetuphrSurchagrTax = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrsurcharge/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPHRSURCHARGETAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getsetuphrCess = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrcess/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPHRCESSTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createsetuphrCess = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrcess/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPHRCESSTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updatesetuphrCess = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrcess/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPHRCESSTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deletesetuphrCess = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrcess/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPHRCESSTAX, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getsetupHrTemplate = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrtemplatefields/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPHRTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createsetupHrTemplate = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrtemplatefields/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPHRTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updatesetupHrTemplate = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrtemplatefields/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPHRTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deletesetupHrTemplate = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrtemplatefields/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPHRTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getsetupHrSurveyTemplate = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrsurveytemplate/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPHRSURVEYTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createsetupHrSurveyTemplate = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrsurveytemplate/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPHRSURVEYTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updatesetupHrSurveyTemplate = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrsurveytemplate/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPHRSURVEYTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deletesetupHrSurveyTemplate = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrsurveytemplate/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPHRSURVEYTEMPLATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createTwoStepVerification = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuptwostepverification/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATE_TWOSTEP_VERIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log("Create Error:", error);
    });
};

export const getTwoStepVerification = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuptwostepverification/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GET_TWOSTEP_VERIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log("Get Error:", error);
    });
};


export const updateTwoStepVerification = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuptwostepverification/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATE_TWOSTEP_VERIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log("Update Error:", error);
    });
};


export const deleteTwoStepVerification = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuptwostepverification/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETE_TWOSTEP_VERIFICATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log("Delete Error:", error);
    });
};

export const getWing = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setupwing/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPWINGLOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createWing = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setupwing/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPWINGLOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateWing = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setupwing/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPWINGLOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteWing = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setupwing/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPWINGLOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getRoom = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuprooms/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: GETSETUPROOMOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createRoom = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuprooms/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: CREATESETUPROOMOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateRoom = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuprooms/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATESETUPROOMOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteRoom = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuprooms/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: DELETESETUPROOMOCATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const clearBedWing = () => ({ type: CLEAR_BED_WING, });
export const clearBedRoom = () => ({ type: CLEAR_BED_ROOM, });
export const clearBedFloor = () => ({ type: CLEAR_BED_FLOOR, });
export const clearBedType = () => ({ type: CLEAR_BED_TYPES, });
export const clearBed = () => ({ type: CLEAR_BED, });
